<template>
    <div class="chat">
        <div class="chat-history">
            <div v-for="(message, index) in messages" :key="index" :class="{'my-message': message.isMine, 'bot-message': !message.isMine, 'message': true}">
                <span v-if="message.isMine">{{ message.text }}</span>
                <span v-else v-html="message.text"></span>
                <span class="actor-icon" v-if="!message.isMine">
                    <img :src="app.image" class="logo" alt="actor-icon">
                </span>
            </div>

            <div class="bot-message message" v-if="botTyping">
                <b-spinner small></b-spinner>
                <span class="actor-icon">
                    <img :src="app.image" class="logo" alt="actor-icon">
                </span>
            </div>
            <div ref="lastMessage"></div>

            <div v-if="disabled" class="alert alert-danger" role="alert">
                Chat is no longer available.
            </div>
        </div>
        <div class="chat-footer">
            <input type="text" v-model="newMessage" autofocus @keyup.enter="sendMessage" class="chat-input" placeholder="Stuur een bericht naar de chatbot..." :disabled="disabled">
            <b-icon-arrow-right-circle-fill class="send-icon" scale="2" @click="sendMessage"></b-icon-arrow-right-circle-fill>
        </div>
    </div>
</template>

<script>

import { v4 as uuidv4 } from 'uuid';

import config from '../config';

const DEMO = false;

export default {
    name: 'Chat',
    data () {
        return {
            newMessage: '',
            messages: [],
            botTyping: false,
            sessionId: uuidv4(),
            disabled: false
        }
    },
    props: {
        app: {
            type: Object,
            required: true
        }
    },
    methods: {
        addMessage(text, isMine) {
            this.messages.push({ text, isMine });
            this.$nextTick(() => {
                this.$refs.lastMessage.scrollIntoView({ behavior: 'smooth', block: 'end' });
            });
        },
        sendMessage() {
            if (!this.newMessage || this.newMessage.trim() === '' || this.botTyping){
                return;
            }
            const token = localStorage.getItem('token') || '';
            const message = this.newMessage;

            this.addMessage(this.newMessage, true);
            
            this.newMessage = '';

            this.botTyping = true;

            this.$nextTick(() => {
                this.$refs.lastMessage.scrollIntoView({ behavior: 'smooth', block: 'end' });
            });

            if (DEMO) {
                setTimeout(() => {
                    this.addMessage('This is a demo chatbot. You can not send messages to the chatbot.', false);
                    this.botTyping = false;
                }, 1000);
                return;
            }
    
            fetch(`${config.api}/chatbot`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
                body: JSON.stringify({
                    session_id: this.sessionId,
                    question: message
                })
            })
                .then(response => response.json())
                .then(data => {
                    this.addMessage(data.answer, false);
                    this.botTyping = false;
                })
                .catch((error) => {
                    this.disabled = true;
                });

        }
    },
    mounted() {
        this.botTyping = true;

        setTimeout(() => {
            this.botTyping = false;

            this.addMessage(this.app.initial_question, false);
        }, 1000);
    }
}
</script>

<style scoped>
.chat {
    height: 100%;
    display: flex;
    flex-direction: column;
    width: 1000px;
}

.chat-history {
    flex-grow: 1;
    overflow-y: auto;
    scrollbar-width: none;
    -ms-overflow-style: none;
    padding: 0 50px 0 50px
}
.chat-history::-webkit-scrollbar {
    display: none;
}

.my-message {
    align-self: flex-end;
    background-color: rgba(244,244,244);
    margin: 10px;
    padding: 10px;
    border-radius: 10px;
    width: 50%;
    margin-left: calc(50% - 30px);
    font-size: 15px;
    
}

.bot-message {
    align-self: flex-start;
    background-color: #ffffff;
    margin: 10px;
    padding: 10px;
    border-radius: 10px;
    width: 50%;
    box-shadow: 0 1px 3px rgba(0,0,0,0.1);
    font-size: 15px;
}

.chat-footer {
    width: 100%;
    position: relative
}

.chat-input {
    padding: 10px 20px;
    border: none;
    border-radius: 20px;
    box-shadow: 0 1px 3px rgba(0,0,0,0.1);
    font-size: 16px;
    outline: none;
    margin: 20px;
    width: 100%;
    background-color: #f6f6f6;
}

.send-icon {
    position: absolute;
    right: 0px;
    top: 34px;
    cursor: pointer;
    color: rgb(146, 146, 146);
    transition: 200ms;
}

.send-icon:hover {
    color: rgb(91, 91, 91);
    transform: scale(1.1);
    transition: 200ms;
}

.send-icon:active {
    color: rgb(37, 37, 37);
    transition: 200ms;
}

.message {
    position: relative;
}

.actor-icon {
    position: absolute;
    left: -48px;
    top: 8px;
    width: 40px;
    z-index: 1
}

</style>


// WEBPACK FOOTER //
// src/components/Chat.vue